import React from 'react';

import styles from 'molecules/Table/table.module.scss';

import { isNonEmptyArray } from 'utils/functions';

import type { TableProps } from 'molecules/Table/config/index';
import type { FC } from 'react';

const TableBuilderComponent: FC<TableProps> = ({ heading, rows }) => (
  <div className={styles.container}>
    {heading && <h5 className={styles.heading}>{heading}</h5>}
    {isNonEmptyArray(rows) && (
      <table>
        <thead>
          <tr>
            {rows[0].columns?.map((column, columnIndex) => (
              <th key={columnIndex}>{column?.content}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.slice(1).map((row, rowIndex) => (
            <tr key={rowIndex}>
              {row.columns?.map((column, columnIndex) => (
                <td key={columnIndex}>{column?.content}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    )}
  </div>
);

export default TableBuilderComponent;
